import React from "react";
const StringKey = ({ stringKey = "Notfound" }) => {
  return <div>{stringKey}</div>;
};

export default StringKey;
